import { FieldRenderProps } from 'react-final-form';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

// custom styling
import './custom.css';

const QuillAdapter = ({ input }: FieldRenderProps<string>) => {
    const toolbarOptions = [
        ['bold', 'italic', 'underline'], // toggled buttons
        ['link', 'image'],

        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

        //[{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }], // dropdown with defaults from theme

        ['formula'],

        ['clean'], // remove formatting button
    ];

    return (
        <ReactQuill
            value={input.value ?? ''}
            modules={{
                toolbar: toolbarOptions,
                clipboard: {
                    matchVisual: false,
                },
            }}
            theme="snow"
            onChange={(newValue, delta, source) => {
                if (source === 'user') {
                    input.onChange(newValue);
                }
            }}
            onBlur={() => {
                input.onBlur();
            }}
            onFocus={() => {
                input.onFocus();
            }}
            className="customQuill"
        />
    );
};

export default QuillAdapter;
